import Link from "next/link";
import styles from "./header.module.css";
import { isDevMode } from "@/lib/env";

type LoginAndSingUpProps = {
  loginURL: string;
  signUpURL: string;
};

const LoginAndSignUp = ({ loginURL, signUpURL }: LoginAndSingUpProps) => {
  const effectiveLoginURL = isDevMode ? "/login" : loginURL || "#";

  return (
    <>
      <div className="text-[#FF8200] uppercase cursor-pointer font-medium font-jost text-[14px] ">
        <Link className={`relative hover:outline-0 px-4 py-2 ${styles.logIn}`} href={effectiveLoginURL}>
          Log In
        </Link>
      </div>
      <Link
        href={signUpURL ? signUpURL : "#"}
        className="bg-[#FF8200] text-white px-5 lg:py-1 xs:py-2 font-medium font-jost text-[14px] border-2 border-[#ff8200] border-solid rounded uppercase">
        Sign up
      </Link>
    </>
  );
};

export default LoginAndSignUp;
